// API base URL
export const BASE_URL = import.meta.env.VITE_API_URL || ""

const DEFAULT_SUPPORT_URL = "https://t.me/Celestia_help"

export const getSupportUrl = (): string => import.meta.env.VITE_SUPPORT_URL || DEFAULT_SUPPORT_URL
